/**
 * Check if the current time is within the given hourly range.
 *
 * @param hourlyRange {string} - hourly range, eg. 7:00 - 15:00
 * @returns {boolean}
 */
export default (hourlyRange) => {
    if (!hourlyRange) {
        return false;
    }

    // match properly formatted hours, eg. 06:25 or 8:05
    const regex = /[0-2]?\d:[0-5]\d/g;
    const hoursArray = hourlyRange.match(regex);

    if (!hoursArray || hoursArray.length !== 2) {
        return false;
    }

    // get hours
    let firstHour = hoursArray[0];
    let secondHour = hoursArray[1];

    // remove colon from hours and convert it to integer
    firstHour = parseInt(firstHour.replace(':', ''), 10);
    secondHour = parseInt(secondHour.replace(':', ''), 10);

    // get current hours and minutes
    const date = new Date();
    const hours = date.getHours();

    // add leading zero to minutes
    const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();

    // join hours and minutes and convert it to integer
    const currentTime = parseInt(`${hours}${minutes}""`, 10);

    return currentTime >= firstHour && currentTime <= secondHour;
};
